<template>
    <div id="field-constraints-select-component">
        <v-autocomplete
            :items="field_constraints"
            :label="$t(scope === 'SITE' ? 'site_constraints' : 'asset_constraints')"
            :loading="fetching_field_constraints"
            :value="value"
            chips
            deletable-chips
            filled
            item-value="uid"
            multiple
            @input="$emit('input', $event)"
        >
            <template v-slot:selection="{ item, select, selected }">
                <v-chip :input-value="selected" close small @click="select" @click:close="removeConstraint(item.uid)">
                    {{ $t(item.name_translation_key) }}
                </v-chip>
            </template>

            <template v-slot:item="{ item }">
                {{ $t(item.name_translation_key) }}
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
import FieldConstraintRepository from '@/repositories/FieldConstraintRepository'

export default {
    name: 'FieldConstraintsSelectComponent',
    props: {
        value: {
            type: Array,
            required: true,
        },
        scope: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            field_constraints: [],
            fetching_field_constraints: false,
        }
    },
    mounted() {
        this.fetchFieldConstraintsByScope()
    },
    methods: {
        fetchFieldConstraintsByScope() {
            this.fetching_field_constraints = true
            FieldConstraintRepository.getByScope(this.scope)
                .then((success) => {
                    this.field_constraints = success.data.data
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.fetching_field_constraints = false
                })
        },

        removeConstraint(uid) {
            this.$emit(
                'input',
                this.value.filter((selectedUid) => selectedUid !== uid),
            )
        },
    },
}
</script>
